import request from '@/utils/request'

// 分页查询应急处理事件进展列表
export function queryEmergencyIncidentList(data) {
  return request({
    url: '/crmEmergencyIncident/queryList',
    method: 'post',
    data: data
  })
}

// 查询应急处理事件进展详情
export function queryEmergencyIncidentDetail(query) {
  return request({
    url: '/crmEmergencyIncident/queryDetail',
    method: 'get',
    params: query
  })
}

// 新增应急处理事件进展
export function addEmergencyIncident(data) {
  return request({
    url: '/crmEmergencyIncident/add',
    method: 'post',
    data: data
  })
}

// 更新应急处理事件进展
export function updateEmergencyIncident(data) {
  return request({
    url: '/crmEmergencyIncident/update',
    method: 'put',
    data: data
  })
}

// 删除应急处理事件进展
export function deleteEmergencyIncident(data) {
  return request({
    url: '/crmEmergencyIncident/delete',
    method: 'delete',
    data: data
  })
}